module.exports = __webpack_public_path__ + "img/jewelry@2x.42937af.webp";